<template>
  <div>
    <default-card v-if="all_events">
        <template slot="title-left"> 
          Calendário 📅 
          <v-col cols='12' class='pa-0 mb-2'>
            <div class='title-financial'>
              {{ $dayjs().format('dddd').toUpperCase() }}, {{ $dayjs().format('DD [de] MMMM').toUpperCase() }}
            </div>
          </v-col>
        </template>
        <template slot="title-right">
          <div class="d-flex mt-n10">
            <div class='year-title'>{{ $dayjs().format('YYYY')}}</div>
            <v-btn
              v-if="is_component_used_in_all_events"
              icon
              color="primary"
              @click="$emit('changeCalendar')"
            >
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
          </div>
        </template>
        <template slot="content">
          <card-loading-transparent v-if="loading"/>
          <div v-if="!loading">
            <v-row class="fill-height">
              <v-col>
                <v-sheet height="64">
                  <v-toolbar flat >
                    <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday" >
                      HOJE
                    </v-btn>
                    <v-btn fab text small color="grey darken-2" @click="prev" >
                      <v-icon small>
                        mdi-chevron-left
                      </v-icon>
                    </v-btn>
                    <v-btn fab text small color="grey darken-2" @click="next" >
                      <v-icon small>
                        mdi-chevron-right
                      </v-icon>
                    </v-btn>
                    <v-toolbar-title v-if="$refs.calendar">
                      {{ $refs.calendar.title }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn v-if="type=='day'" outlined class="mr-4" color="grey darken-2" @click="type = 'month'" >
                      Ver Mensal
                    </v-btn>
                  </v-toolbar>
                </v-sheet>
                <v-sheet height="600">
                  <v-calendar ref="calendar" color="primary" :type="type" v-model="focus"
                    :events="eventsWithDateMapped" event-start="start_at" event-end="end_at"
                    @click:event="showEvent"
                    @click:more="viewDay"
                    @click:date="viewDay"
                    @change="updateRange"
                    :short-intervals="false"
                  >
                    <template v-slot:event="{ event }">
                      <div class="v-event-draggable">
                        <strong>{{ formatEventTitle(event.name) }}</strong>
                        <!-- {{ formatEventTime(event) }} -->
                      </div>
                    </template>
                  </v-calendar>
                  <v-dialog v-model="selected_dialog" max-width="620">
                    <selected-event-card
                      style="overflow: hidden !important;"
                      v-if="selected_event"
                      short_description
                      @closeDialog="handleClose"
                      :selected_event="selected_event"
                    ></selected-event-card>
                  </v-dialog>
                </v-sheet>
              </v-col>
            </v-row>
          </div>
        </template>
      <template slot="actions"> </template>
    </default-card>
  </div>
</template>

<script>
  import Api from '@/api'
  import { mapState, mapActions, mapGetters } from 'vuex';

  export default {
    name: 'EventsCalendar',
    components: {
      SelectedEventCard: () => import('./SelectedEventCard.vue'),
    },
    props: {
      is_component_used_in_all_events: {
        type: Boolean,
        default: false,
      },
      use_with_menu: {
        type: Boolean,
        default: false,
      },
      use_with_emit: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      loading: false,
      focus: '',
      type: 'month',
      selected_event: {},
      selected_element: null,
      selected_dialog: false,
      events: [],
      all_events: []
    }),
    mounted () {
      this.getData()
      //this.$refs.calendar.checkChange()
    },
    watch: {
      activeCompanyId(){
        this.getData()
        this.selected_event = {}
      }
    },
    methods: {
      handleClose(){
        this.selected_dialog = false
      },
      getData(){
        if(this.activeCompanyId){
          this.loading = true;
          let filter = {
            company_id: this.activeCompanyId
          }
          Api.Event.index(filter).then(r=>r.data).then(d=> {
            this.all_events = []
            d.map((event)=>{
              if(event.category == 'event'){
                event.end_at = event.start_at
              }
              this.all_events.push(event)
            })
            if(this.use_with_emit && d[0]){
              let next = d.filter(e=> {
                return this.$dayjs(e.start_at).isBetween(this.$dayjs(), this.$dayjs().endOf('year'))
              })
              this.$emit('selectedEvent', next.slice(-1)[0] || {})
            }
          }).catch((err) => {
            console.log(err);
          }).finally(()=>{
            this.loading = false;
          })
        }
      },
      viewDay (date) {
        this.focus = date.date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        if(this.use_with_menu){
          const open = () => {
            this.selected_event = event
            this.selected_element = nativeEvent.target
            requestAnimationFrame(() => requestAnimationFrame(() => this.selected_dialog = true))
          }
          if (this.selected_dialog) {
            this.selected_dialog = false
            requestAnimationFrame(() => requestAnimationFrame(() => open()))
          } else {
            open()
          }
          nativeEvent.stopPropagation()
        }else if(this.use_with_emit){
          this.$emit('selectedEvent', {...event,scroll:true})
        }
      },
      updateRange ({start, end}) {

        let filtered_events = []

        if(this.type == 'day'){
          filtered_events = this.eventsWithDateMapped.filter( (el) => {
            return this.$dayjs(start.date).isBetween(this.$dayjs(el.start_at), this.$dayjs(el.end_at), 'day', [])
          })
        }else if(this.type == 'month' && this.events){
          filtered_events = this.eventsWithDateMapped.filter( (el) => {
            return this.$dayjs(start.date).isBetween(this.$dayjs(el.start_at), this.$dayjs(el.end_at), 'day', []) ||
            this.$dayjs(end.date).isBetween(this.$dayjs(el.start_at), this.$dayjs(el.end_at), 'day', []) ||
            this.$dayjs(el.start_at).isSameOrAfter(this.$dayjs(start.date)) ||
            this.$dayjs(el.end_at).isSameOrBefore(this.$dayjs(end.date)) 
          })
        }
        this.events = filtered_events || []  
      },
      formatEventTime({start_at, end_at}) {        
        return `${this.$dayjs(start_at).format('HH:mm')} - ${this.$dayjs(end_at).format('HH:mm')}`
      },
      formatEventTitle(name){
        if(name && name.length > 12){
          return `${name.slice(0, 8) }...`
        }else{
          return name
        }
      },
    },
    computed: {
      ...mapState({
        activeCompanyId: state => state.App.activeCompanyId
      }),
      eventsWithDateMapped(){
        let events_mapped = []
        this.all_events.map(item => {
          if(item.start_at != null){
            if(item.category == 'event'){
              item.start_at = this.$dayjs(item.start_at).format('YYYY-MM-DD HH:mm')
              if (item.end_at){
                item.end_at = this.$dayjs(item.end_at).format('YYYY-MM-DD HH:mm')
              } else {
                item.end_at = this.$dayjs(item.start_at).format('YYYY-MM-DD HH:mm')
              }
            }else{
              item.start_at = this.$dayjs(item.start_at).format('YYYY-MM-DD HH:mm')
              item.end_at = this.$dayjs(item.end_at).format('YYYY-MM-DD HH:mm')
            }
            events_mapped.push(item)
          }
        })
        return events_mapped
      },
    },
  }
</script>

<style lang="scss">
  .year-title{
    color: var(--v-primary-base) !important;
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: 0.05em !important;
    font-family: "Roboto", sans-serif !important;
    text-transform: uppercase !important;
    margin-top: 2.5px;
  }
</style>